import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SidebarContextProvider } from "./store/sidebarContext";
import { LangContextProvider } from "./store/langContext";
import { ThemeContextProvider } from "./store/themeContext";
import { LoginContextProvider } from "./store/loginContext";

console.log('React app starting...');
console.log('Environment:', process.env.NODE_ENV);
console.log('Public URL:', process.env.PUBLIC_URL);

const container = document.getElementById("root");
const root = createRoot(container!);

try {
  console.log('Rendering App component...');
  root.render(
    <LangContextProvider>
      <LoginContextProvider>
        <ThemeContextProvider>
          <SidebarContextProvider>
            <App />
          </SidebarContextProvider>
        </ThemeContextProvider>
      </LoginContextProvider>
    </LangContextProvider>
  );
  console.log('App component rendered successfully');
} catch (error) {
  console.error(' Error rendering App component:', error);
}
